import { render, staticRenderFns } from "./uploadthIndex.vue?vue&type=template&id=71e5947b&scoped=true&"
import script from "./uploadthIndex.vue?vue&type=script&lang=js&"
export * from "./uploadthIndex.vue?vue&type=script&lang=js&"
import style0 from "./uploadthIndex.vue?vue&type=style&index=0&id=71e5947b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e5947b",
  null
  
)

export default component.exports